import React from 'react'
import styled, { css } from 'styled-components'
import { breakpoint } from 'utils'

type GroupNameProps = React.PropsWithChildren<{
  groups: string
}>

const GroupContainer = styled.span`
  margin-left: 4px;

  ${breakpoint('sm')`
    margin-left: 24px;
  `};
`

const GroupNameMain = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.body};
    font-weight: ${theme.fontWeights.medium};
  `
)

const GroupNameMainWithSpacing = styled(GroupNameMain)`
  margin-left: 4px;
`

const GroupNameSecondary = styled(GroupNameMain)(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary[4]};

    & + & {
      margin: 0 4px;
    }
  `
)

export const GroupName = ({ groups }: GroupNameProps) => {
  if (groups === '') {
    return (
      <GroupContainer>
        <GroupNameMain> </GroupNameMain>
      </GroupContainer>
    )
  }

  const groupsArray = groups.split('/')

  if (groupsArray.length === 1) {
    return (
      <GroupContainer>
        <GroupNameMain>{groupsArray[0]}</GroupNameMain>
      </GroupContainer>
    )
  }

  return (
    <GroupContainer>
      {groupsArray.map((group, key) =>
        key !== groupsArray.length - 1 ? (
          <GroupNameSecondary>{group} /</GroupNameSecondary>
        ) : (
          <GroupNameMainWithSpacing>{group}</GroupNameMainWithSpacing>
        )
      )}
    </GroupContainer>
  )
}
